"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimePeriodSelector = void 0;
var classnames_1 = __importDefault(require("classnames"));
var date_fns_1 = require("date-fns");
var React = __importStar(require("react"));
var __1 = require("..");
var defaultLengthMinutes = 120;
var isValidDateTimeString = function (dateTime) {
    return dateTime && !isNaN(Date.parse(dateTime));
};
var DateTimePeriodSelector = function (_a) {
    var _b, _c;
    var onChange = _a.onChange, value = _a.value, _d = _a.stepSize, stepSize = _d === void 0 ? 15 : _d, limits = _a.limits, disabled = _a.disabled, timeFormatter = _a.timeFormatter;
    // Valid checks
    var isStartValid = isValidDateTimeString(value.start);
    var isEndValid = isValidDateTimeString(value.end);
    // Setup date objects, when null we fall back to defaults later
    var dtpStart = isStartValid ? new Date(value.start) : null;
    var dtpEnd = isEndValid ? new Date(value.end) : null;
    var dtpMin = isValidDateTimeString(limits === null || limits === void 0 ? void 0 : limits.min)
        ? new Date(limits.min)
        : (0, date_fns_1.set)(dtpStart || new Date(), {
            hours: 8,
            minutes: 0
        });
    var dtpMax = isValidDateTimeString(limits === null || limits === void 0 ? void 0 : limits.max)
        ? new Date(limits.max)
        : (0, date_fns_1.set)(dtpEnd || new Date(), {
            hours: 22,
            minutes: 0
        });
    /*
     *
     */
    var start = (0, date_fns_1.set)(dtpStart || dtpMin, {
        seconds: 0,
        milliseconds: 0
    });
    var end = (0, date_fns_1.set)(dtpEnd || dtpMax, {
        seconds: 0,
        milliseconds: 0
    });
    /**
     * Update function for increasing / decreasing both start and end
     */
    var updateBoth = function (operation) {
        if (disabled) {
            // for all the hAcKeRs out there <3
            return;
        }
        if (operation === 'increase') {
            onChange({
                start: (0, date_fns_1.addMinutes)(start, stepSize).toISOString(),
                end: (0, date_fns_1.addMinutes)(end, stepSize).toISOString()
            });
            return;
        }
        onChange({
            start: (0, date_fns_1.subMinutes)(start, stepSize).toISOString(),
            end: (0, date_fns_1.subMinutes)(end, stepSize).toISOString()
        });
    };
    /**
     * Update function for setting either start or end
     */
    var updateSingle = function (type, newTimeValue) {
        if (disabled) {
            // for all the hAcKeRs out there <3
            return;
        }
        if (!newTimeValue)
            return;
        if (type === 'start') {
            onChange({
                start: newTimeValue,
                end: value.end
            });
            return;
        }
        onChange({
            start: value.start,
            end: newTimeValue
        });
    };
    return (React.createElement(__1.ControlsWrapper, { onChangeMinus: function () { return updateBoth('decrease'); }, onChangePlus: function () { return updateBoth('increase'); }, disabledMinus: disabled || (0, date_fns_1.isBefore)((0, date_fns_1.subMinutes)(start, stepSize), dtpMin), disabledPlus: disabled || (0, date_fns_1.isAfter)((0, date_fns_1.addMinutes)(end, stepSize), dtpMax) },
        React.createElement("div", { className: (0, classnames_1.default)('br-flex', 'br-justify-center', 'br-rounded-default', 'br-border', 'br-border-solid', 'br-border-gray-500') },
            React.createElement(TimeInput, { value: start, step: stepSize, min: dtpMin, max: (0, date_fns_1.subMinutes)(end, ((_b = limits === null || limits === void 0 ? void 0 : limits.length) === null || _b === void 0 ? void 0 : _b.minutes) || defaultLengthMinutes), onChange: function (v) { return updateSingle('start', v); }, disabled: disabled, timeFormatter: timeFormatter }),
            React.createElement(__1.Spacer, { w: 2 }),
            React.createElement(TimeInput, { value: end, step: stepSize, min: (0, date_fns_1.addMinutes)(start, ((_c = limits === null || limits === void 0 ? void 0 : limits.length) === null || _c === void 0 ? void 0 : _c.minutes) || defaultLengthMinutes), max: dtpMax, onChange: function (v) { return updateSingle('end', v); }, disabled: disabled, timeFormatter: timeFormatter }))));
};
exports.DateTimePeriodSelector = DateTimePeriodSelector;
var TimeInput = function (_a) {
    var value = _a.value, step = _a.step, min = _a.min, max = _a.max, onChange = _a.onChange, disabled = _a.disabled, timeFormatter = _a.timeFormatter;
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    var wrapperCns = [
        'br-px-2',
        'br-border-b',
        'br-border-solid',
        'br-border-gray-500',
        'br-h-9',
        { 'br-pt-2': isMobile },
        { 'br-h-auto': !isMobile }
    ];
    if (isMobile) {
        return (React.createElement("div", { className: (0, classnames_1.default)(wrapperCns), style: { marginBottom: '.4em' } },
            React.createElement(__1.Label, { text: React.createElement("span", { className: (0, classnames_1.default)('br-inline-flex', 'br-items-center') },
                    timeFormatter(value),
                    ' ',
                    React.createElement(__1.IconBrengerSmile, { className: (0, classnames_1.default)('br-ml-2', 'br-text-blue-600', 'br-h-2', 'br-w-2') })) },
                React.createElement("input", { className: (0, classnames_1.default)('br-hidden'), type: "time", 
                    // Step size is always in seconds when it is a time input.
                    step: step * 60, 
                    // value, min, max, are always 24h notation => 09:59
                    value: timeFormatter(value), min: timeFormatter(min), max: timeFormatter(max), disabled: disabled, onChange: function (e) {
                        var val = e.currentTarget.value;
                        if (!val)
                            return;
                        // friendly reminder, 24h notation => 09:59
                        var _a = val.split(':'), hours = _a[0], minutes = _a[1];
                        /**
                         * We make use of the value, which contains the date, we update the time only
                         */
                        var newDateTime = (0, date_fns_1.set)(value, {
                            minutes: Number(minutes),
                            hours: Number(hours)
                        });
                        /**
                         * Unforunately the time input does not restrict explicitly min and max input
                         * So we need to check manually
                         */
                        if ((0, date_fns_1.isBefore)(newDateTime, min)) {
                            onChange(min.toISOString());
                            return;
                        }
                        if ((0, date_fns_1.isAfter)(newDateTime, max)) {
                            onChange(max.toISOString());
                            return;
                        }
                        onChange(newDateTime.toISOString());
                    } }))));
    }
    /**
     * When web: the native time input works very shitty, so we return a select with a set of options
     */
    // first option is the minimum value
    var option = min;
    var options = [{ value: option.toISOString(), label: timeFormatter(option) }];
    /**
     * Then we keep adding options by increasing with step size (in munites)
     */
    do {
        option = (0, date_fns_1.addMinutes)(option, step);
        options.push({ value: option.toISOString(), label: timeFormatter(option) });
        // While the current option is before the maximum time input
    } while ((0, date_fns_1.isBefore)(option, max));
    return (React.createElement("div", { className: (0, classnames_1.default)(wrapperCns), style: { marginBottom: '.4em', paddingTop: '.4em' } },
        React.createElement(__1.Select, { value: value.toISOString(), onChange: onChange, noDefaultClasses: true, disabled: disabled, className: (0, classnames_1.default)('br-border-0', 'br-bg-transparent', 'br-p-1', 'br-pr-4', 'br-outline-0', 'focus:br-ring-0'), iconClassName: (0, classnames_1.default)('br-text-blue-600', 'br-absolute', 'br-top-2', 'br-right-0', 'br-h-2', 'br-w-2') }, options.map(function (o, i) {
            return (React.createElement("option", { key: i, value: o.value }, o.label));
        }))));
};
